import { Injectable } from "@angular/core";
import { PowerSupplyModel, DefaultService } from "@psnb/psnb-api";
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PowerSupplyModelsService {
  constructor(private powerSupplyService: DefaultService) {
    this.getPowerSupplyModels();
  }

  public getPowerSupplyModels() {
    return this.powerSupplyService.getPowerSupplyModels()
      .pipe(map(result => result));
  }

  public createPowerSupplyModel(model: PowerSupplyModel) {
    return this.powerSupplyService.createPowerSupplyModel(model)
      .pipe(map(result => result));
  }

  public updatePowerSupplyModel(model: PowerSupplyModel) {
    return this.powerSupplyService.updatePowerSupplyModel(model)
      .pipe(map(result => result));
  }

  public deletePowerSupplyModel(id: number) {
    return this.powerSupplyService.deletePowerSupplyModel(id)
      .pipe(map(result => result));
  }
}
